'use strict';

function NnLazyBackgroundDirective() {

  'ngInject';

  return {
    restrict: 'A',
    scope: {
      lazyBackground: '@'
    },
    link: function(scope, element) {
      const observer = new IntersectionObserver(loadImg)
      const img = angular.element(element)[0];
      observer.observe(img)

      function loadImg(changes) {
        changes.forEach(change => {
          if (change.isIntersecting) {
            change.target.style.background = `no-repeat center center`;
            change.target.style.backgroundSize = `cover`;
            change.target.style.backgroundImage = `url('${scope.lazyBackground}')`;
          }
        })
      }

      scope.$watch('lazyBackground', (newVal, oldVal) => {
        if (newVal === oldVal) {
          return
        }

        img.style.backgroundImage = `url('${newVal}')`
      })
    }
  }
}

export default NnLazyBackgroundDirective



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-lazy-background.directive.js